import { render, staticRenderFns } from "./EditGoods.vue?vue&type=template&id=b6d5ab30&scoped=true&"
import script from "./EditGoods.vue?vue&type=script&lang=js&"
export * from "./EditGoods.vue?vue&type=script&lang=js&"
import style0 from "./EditGoods.vue?vue&type=style&index=0&id=b6d5ab30&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6d5ab30",
  null
  
)

export default component.exports